import React from 'react';
import { cn } from '../../lib/utils';

const Form = ({ children, className, onSubmit, ...props }) => (
  <form 
    className={cn("space-y-4", className)} 
    onSubmit={onSubmit}
    {...props}
  >
    {children}
  </form>
);

const FormGroup = ({ children, className }) => (
  <div className={cn("space-y-2", className)}>
    {children}
  </div>
);

const FormLabel = ({ children, htmlFor, className, required }) => (
  <label 
    htmlFor={htmlFor}
    className={cn(
      "block text-sm font-medium text-gray-700 dark:text-gray-300",
      className
    )}
  >
    {children}
    {required && <span className="text-red-500 ml-1">*</span>}
  </label>
);

const FormInput = ({ className, type = "text", ...props }) => (
  <input
    type={type}
    className={cn(
      "block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-gray-100 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed",
      className
    )}
    {...props}
  />
);

const FormTextarea = ({ className, rows = 3, ...props }) => (
  <textarea
    rows={rows}
    className={cn(
      "block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-gray-100 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed resize-vertical",
      className
    )}
    {...props}
  />
);

const FormSelect = ({ className, children, ...props }) => (
  <select
    className={cn(
      "block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed",
      className
    )}
    {...props}
  >
    {children}
  </select>
);

const FormCheckbox = ({ className, label, ...props }) => (
  <div className="flex items-center">
    <input
      type="checkbox"
      className={cn(
        "h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-red-600 focus:ring-red-500 focus:ring-2 bg-white dark:bg-gray-800",
        className
      )}
      {...props}
    />
    {label && (
      <label className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
        {label}
      </label>
    )}
  </div>
);

const FormText = ({ children, className, variant = "muted" }) => (
  <p className={cn(
    "text-sm",
    variant === "muted" && "text-gray-500 dark:text-gray-400",
    variant === "error" && "text-red-600 dark:text-red-400",
    className
  )}>
    {children}
  </p>
);

export { 
  Form, 
  FormGroup, 
  FormLabel, 
  FormInput, 
  FormTextarea, 
  FormSelect, 
  FormCheckbox, 
  FormText 
};
